module.exports = "../ajax.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/ajax.gif
// module id = ./src/assets/img/ajax.gif
// module chunks = 1